module.exports = __webpack_public_path__ + "static/media/24_CORTINAO_SEM_BOJO_ESTAMPADO_01.119ba019.jpg";